export const moreInfoPackage = [
    {
        title: 'Що ми не робимо',
        description: [
            'Не миємо вікна ззовні (замовте додаткову послугу “Миття з 2-х сторін”)',
            'Не проводимо хімчистку меблів та килимів (замовте додаткову послугу “Хімчитска”)',
            'Не протираємо кришталеві люстри та світильники (замовте додаткову послугу)',
            'Не миємо всередині холодильника та печі (замовте додаткову послугу)'
        ]
    },
    {
        title: 'All Included',
        description: [
            'Миємо та дизенфікуємо ванну кімнуту та туалет',
            'Не проводимо хімчистку меблів та килимів (замовте додаткову послугу “Хімчитска”)',
            'Миємо вікна з внутрішньої сторони.'
        ]
    },
    {
        title: 'Кухня',
        description: [
            'Миємо та дезинфікуємо фасад кухні',
            'Миємо кухонну плиту та стіну над нею',
            'Миємо витяжку'
        ]
    },
    {
        title: 'Ванна кімната',
        description: [
            'Чистимо та дезинфікуємо сантехніку',
            'Миємо ванну та душову кабіну',
            'Видаляємо локальні забрудення на висоті до 2 м'
        ]
    },
]